import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { get } from 'lodash';
import { Controller, useFormContext } from 'react-hook-form';
import StyledCheckbox from '~/components/ui/Form/StyledCheckbox';
import { helperTextClassNames, labelClassNames } from '~/components/ui/Form/StyledInput';

const CheckboxField = ({ field, name, label, helperText }) => {
    const {
        register,
        control,
        formState: { errors }
    } = useFormContext();
    const fieldName = name || field.name;
    const options = Array.isArray(field.options) ? field.options.filter(Boolean) : [];
    const error = get(errors, fieldName);
    const message = error?.message || helperText;

    if (options.length > 0) {
        const isMultiple = field.selectionMode !== 'single';

        return (
            <div className="tw-my-1">
                <label className={labelClassNames({ isInvalid: !!error })}>{label}</label>
                <div className="tw-flex tw-flex-col tw-gap-2 tw-pl-1">
                    {isMultiple ? (
                        <Controller
                            control={control}
                            name={fieldName}
                            defaultValue={[]}
                            render={({ field: { value, onChange } }) =>
                                options.map((option) => (
                                    <StyledCheckbox
                                        key={option}
                                        label={option}
                                        isSelected={Array.isArray(value) && value.includes(option)}
                                        onChange={(checked) => {
                                            const currentValue = Array.isArray(value) ? value : [];
                                            const next = checked
                                                ? [...currentValue, option]
                                                : currentValue.filter((v) => v !== option);
                                            onChange(next);
                                        }}
                                    />
                                ))
                            }
                        />
                    ) : (
                        options.map((option) => (
                            <label key={option} className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2">
                                <span className="tw-relative tw-h-5 tw-w-5">
                                    <input
                                        {...register(fieldName)}
                                        type="radio"
                                        value={option}
                                        className="tw-peer tw-h-5 tw-w-5 tw-appearance-none tw-rounded-md tw-border tw-border-solid tw-border-accents-2 tw-bg-white checked:tw-border-success checked:tw-bg-success focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-success"
                                    />

                                    <FontAwesomeIcon
                                        icon={faCheck}
                                        className="tw-pointer-events-none tw-absolute tw-left-1/2 tw-top-1/2 tw-hidden tw-h-3 tw-w-3 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-text-white peer-checked:tw-block"
                                    />
                                </span>

                                <span className="tw-select-none tw-text-sm tw-text-accents-9">{option}</span>
                            </label>
                        ))
                    )}
                </div>
                {message && <span className={helperTextClassNames({ isInvalid: !!error })}>{message}</span>}
            </div>
        );
    }

    return (
        <div className="tw-my-1">
            <Controller
                control={control}
                name={fieldName}
                render={({ field: { value, onChange } }) => (
                    <StyledCheckbox label={label} isSelected={Boolean(value)} onChange={onChange} />
                )}
            />
            {field.link && (
                <a
                    href={field.link}
                    target="_blank"
                    rel="noreferrer"
                    className="tw-ml-7 tw-mt-1 tw-inline-block tw-text-xs tw-text-success tw-underline"
                >
                    Link öffnen
                </a>
            )}
            {message && <span className={`${helperTextClassNames({ isInvalid: !!error })} tw-ml-7`}>{message}</span>}
        </div>
    );
};

export default CheckboxField;
